<script setup lang="ts" name="FieldBaseError">
const props = withDefaults(
  defineProps<{
    error: string;
    dataTest?: string;
  }>(),
  {
    dataTest: 'error',
  },
);
</script>

<template>
  <p :data-test="dataTest" class="text-xs text-red-6">
    {{ error }}
  </p>
</template>
